/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const digipost = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.856 3v-.35a1 1 0 0 1 1-1h5.175a1 1 0 0 1 .764.354l2.639 3.119a1 1 0 0 1 .237.646v7.582a1 1 0 0 1-1 1H4.856a1 1 0 0 1-1-1V13"
    />
    <path
      fill="#000"
      d="M5.229 4.35v2.394c-.342-.39-.827-.589-1.397-.589-1.254 0-2.232 1.083-2.232 2.47 0 1.387.978 2.47 2.232 2.47.656 0 1.197-.266 1.549-.788V11h1.235V4.35H5.229ZM4.06 9.993c-.646 0-1.073-.55-1.073-1.368 0-.817.427-1.368 1.073-1.368.703 0 1.169.551 1.169 1.368 0 .817-.466 1.368-1.169 1.368Z"
    />
  </svg>
)
export default digipost
